<template src="../templates/normal_fcont_145.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfilePepal from '../components/CreatorProfilePepal'
import UseDesignPaperList from '../components/UseDesignPaperList';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreatorProfilePepal,
    UseDesignPaperList,InfoMachineTranslation,
    AppDownloadCreative,AppDownloadiPrint,AppDownloadSmartPanel,AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['145-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['145-2']}
      ]
    };
  }
  
};
</script>
<style >
</style>

